import React, { useState } from "react";
import { Modal, message } from "antd";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import { Container, TextField, Box, Button, CircularProgress } from "@mui/material";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import axios from "../../axiosInstance";

const EditAcademicExamTimeTable = ({id, examTimeTableTitle, examTimeTableDesc, refreshData}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState(examTimeTableTitle);
  const [desc, setDesc] = useState(examTimeTableDesc);

  // Open modal
  const showModal = () => {
    setIsModalOpen(true);
  };

  // Close modal
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  // Confirm dialog from Ant Design
  const { confirm } = Modal;

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    confirm({
      title: "Confirm Edit",
      content: "Are you sure you want to update the exam time table?",
      okText: "Yes",
      cancelText: "No",
      onOk: async () => {
        setLoading(true);
        // Prepare data for submission
        const UpdateData = {
          id,
          title,
          desc,
        };
        try {
            const { data } = await axios.put(
              "/api/v1/academic-exam-time-table/admin-update",UpdateData,);
            if (data.success === true) {
              message.success(data.message);
              refreshData();
            } else {
              message.error(data?.message);
            }
          } catch (error) {
            message.error(error?.response?.data?.message);
          } finally {
            setLoading(false);
          }
        setIsModalOpen(false);
      },
    });
  };

  return (
    <>
      <IconButton aria-label="edit" onClick={showModal}>
        <EditIcon sx={{ color: "#1976d2" }} />
      </IconButton>

      <Modal
        title="Edit Academic Exam Time Table"
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null} // No default footer buttons
      >
        <Container
          component="form"
          onSubmit={handleSubmit}
          className="form_style border-style"
        >
          <TextField
            sx={{
              mb: 3,
              "& .MuiInputBase-root": {
                color: "text.secondary",
              },
              fieldset: { borderColor: "rgb(231, 235, 240)" },
            }}
            fullWidth
            id="title"
            label="Title *"
            name="title"
            InputLabelProps={{
              shrink: true,
            }}
            placeholder="Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />

          <h4>Description </h4>
          <ReactQuill
            value={desc}
            onChange={setDesc}
            placeholder="Description"
            style={{
              // height: "200px",
              marginBottom: "30px",
              border: "1px solid rgba(0,0,0,0.1)",
              borderRadius: "10px",
            }}
          />

          <Button
            disabled={loading}
            type="submit"
            variant="contained"
            color="primary"
            className="courses_desc"
            sx={{
              mt: 3,
              borderRadius: "5px",
              textTransform: "none",
              fontFamily: "Poppins, sans-serif",
              letterSpacing: ".1rem",
            }}
          >
            {loading ? <CircularProgress size={24} /> : " Edit Exam Time Table"}
          </Button>
        </Container>
      </Modal>
    </>
  );
};

export default EditAcademicExamTimeTable;
